export const REGIONS = {
  GB: {
    code: "GB",
    name: "United Kingdom",
    currency: "GBP",
    symbol: "£",
  },
  CA: {
    code: "CA",
    name: "Canada",
    currency: "CAD",
    symbol: "CA$",
  },
};

export const DEFAULT_REGION = "GB";

export function getSavedRegion() {
  if (typeof window === "undefined") {
    return DEFAULT_REGION;
  }

  const savedRegion = localStorage.getItem("solksites-region");

  if (savedRegion && REGIONS[savedRegion]) {
    return savedRegion;
  }

  return DEFAULT_REGION;
}

export function getCurrencyForRegion(region) {
  return REGIONS[region]?.currency || REGIONS[DEFAULT_REGION].currency;
}

export function formatPrice(amount, currency = "GBP") {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

